@import '../../../../constants/spacing.module.less';

.description-wrapper {
  display: flex;
  gap: @space-16;
  align-self: flex-end;
}

.description-not-active {
  color: var(--grey-600);
}

.progress-bar-wrapper {
  margin-top: @space-8;
  width: 100%;
  gap: @space-8;
}
